<template>
  <div class="flex-col">
    <div class="goods-box">
      <div class="goods-banner">
        <slot :list="list" :current="child.current">
          <div class="banner-wrap">
            <el-image
              lazy
              class="banner-img"
              :class="{ 'img-fading': transitioning }"
              :src="child.src"
              fit="fill"
            />
            <!-- <div class="goods-search flex-center">
              <span @click.stop="toSearchImg(child.src)">{{ $t('cart.wslang1276') }}</span>
            </div> -->
          </div>
        </slot>
      </div>
      <div class="goods-min-img">
        <div
          v-for="(item, index) in list.slice(0, 5)"
          :key="item.picPath"
          class="min-img"
          :class="child.current === index ? 'img-act' : ''"
          @click="change(index, item)"
        >
          <slot name="min" :item="item" :current="child.current">
            <el-image lazy style="width: 100%; height: 100%" :src="item[label] || item" fit="fill" />
          </slot>
        </div>
      </div>
    </div>
    <div class="flex-grow"></div>
  </div>
</template>

<script>
export default {
  props: {
    list: { type: Array, default: () => [] },
    current: { type: Number, default: 0 },
    label: { type: [String, Number], default: 'picPath' },
    keys: { type: [String, Number], default: 'id' },
    currentSrc: { type: String, default: undefined },
  },
  data() {
    return {
      child: {
        src: undefined,
        current: this.current,
      },
      play: undefined,
      transitioning: false,
    }
  },
  watch: {
    list: {
      handler(val) {
        if (val.length > 0) {
          this.child.src = val[this.child.current][this.label] || val[this.child.current]
          this.startAutoPlay()
        }
      },
      deep: true,
      immediate: true,
    },
    currentSrc(val) {
      if (val) {
        this.stopAutoPlay()
        this.switchSrc(val, this.child.current)
      } else {
        this.startAutoPlay()
      }
    },
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    // 带淡入淡出地切换图片
    switchSrc(src, index) {
      this.transitioning = true
      setTimeout(() => {
        this.child.src = src
        this.child.current = index
        this.transitioning = false
      }, 300)
    },
    startAutoPlay() {
      this.stopAutoPlay()
      this.play = setInterval(() => {
        const next = this.child.current < this.list.length - 1 ? this.child.current + 1 : 0
        this.switchSrc(this.list[next][this.label] || this.list[next], next)
      }, 5000)
    },
    stopAutoPlay() {
      if (this.play) {
        clearInterval(this.play)
        this.play = undefined
      }
    },
    change(index, item) {
      this.stopAutoPlay()
      this.switchSrc(item[this.label] || item, index)
      setTimeout(() => this.startAutoPlay(), 2000)
    },
    // toSearchImg(url) {
    //   this.$router.push({ path: '/newSearchImg', query: { imgUrl: url } })
    // },
  },
}
</script>

<style scoped>
.goods-box {
  height: auto;
  width: auto;
  display: flex;
  flex-direction: row;
}

.goods-banner {
  width: 360px;
  min-width: 360px;
  box-sizing: border-box;
}

.banner-wrap {
  width: 360px;
  height: 360px;
  position: relative;
}

.banner-img {
  width: 360px;
  height: 360px;
  display: block;
  /* position: absolute; */
  /* top: 0;
  left: 0; */
  transition: opacity 0.3s ease;
}

.img-fading {
  opacity: 0;
}

/* 占位，撑开父容器高度 */
.goods-banner > div {
  width: 360px;
  height: 360px;
  position: relative;
}

.goods-min-img {
  min-width: calc(360px / 5 - 5px);
  width: calc(360px / 5 - 5px);
  margin-left: 5px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
}

.min-img {
  height: calc(360px / 5 - 5px);
  width: 100%;
  margin-bottom: 5px;
  cursor: pointer;
}

.min-img:hover {
  opacity: 0.8;
}

.img-act {
  border: 1px solid #FF8726;
}

.goods-search {
  position: absolute;
  height: 24px;
  padding: 0 10px;
  box-shadow: 0px 0px 10px 0px gainsboro;
  background: #ffffff;
  border-radius: 20px;
  z-index: 10;
  font-size: 12px;
  color: #31c643;
  left: 10px;
  top: 5px;
  cursor: pointer;
}

/* 淡入淡出由 .img-fading + transition 控制，无需 Vue transition 组件 */

@media screen and (max-width: 768px) {
  .goods-box {
    flex-direction: column;
  }

  .goods-banner {
    width: 100%;
    min-width: unset;
  }

  .goods-banner > div,
  .banner-img {
    width: 100%;
    height: auto;
    min-height: 360px;
  }

  .goods-min-img {
    flex-direction: row;
    width: 100%;
    margin: 5px 0 0;
    gap: 5px;
  }

  .min-img {
    margin: 0;
    flex: 1;
    height: 60px;
  }
}
</style>

